export default "__VITE_ASSET__42c2d83d__"